import { Box, Paper, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"

const PaymentDeliveryBadge7 = () => {
  const { t } = useTranslation()

  return (
    <Box>
      <Paper
        elevation={0}
        sx={{
          background: "linear-gradient(180deg, #3ebf90, #3ebf90)",
          px: 1,
          py: 0.5,
          borderRadius: "50px",
        }}
      >
        <Typography
          fontSize="11px"
          lineHeight="13px"
          color="#FFFFFF"
          fontWeight={600}
        >
          {t("checkout.v7.payments.deliveryBadge").toUpperCase()}
        </Typography>
      </Paper>
    </Box>
  )
}

export default PaymentDeliveryBadge7
